import * as types from '../constants/action-types';
import update from 'immutability-helper';

const initialState = {
  syncIsFetching: false,
  status: '', // sync status
  syncErrorSpaceIds: [],
  externalCalendars: {
    isFetching: false,
    calendars: [],
    error: ''
  }, // all external calendars from user
  calendarData: {
    isFetching: false,
    calendar: {},
    error: ''
  } // contains data about synced calendar
};

export default function sync (state = initialState, action) {
  const { status, externalCalendars, calendarData, syncErrorSpaceIds } = action;
  switch (action.type) {
  case types.SYNC_REQUEST:
    return update(state, {
      syncIsFetching: { $set: true },
      calendarData: { $merge: calendarData }
    });

  case types.SYNC_SUCCESS:
    return update(state, {
      syncIsFetching: { $set: false },
      status: { $set: status },
      calendarData: { $set: calendarData }
    });

  case types.SYNC_FAILURE:
    return update(state, {
      syncIsFetching: { $set: false },
      calendarData: { $set: calendarData }
    });

  case types.CALENDAR_SYNC_FETCH_REQUEST:
    return update(state, {
      externalCalendars: { $merge: externalCalendars }
    });

  case types.CALENDAR_SYNC_FETCH_SUCCESS:
    return update(state, {
      externalCalendars: { $merge: externalCalendars }
    });

  case types.CALENDAR_SYNC_FETCH_FAILURE:
    return update(state, {
      externalCalendars: { $merge: externalCalendars }
    });

  case types.FETCH_SYNC_STATUS_SUCCESS:
    return update(state, {
      syncErrorSpaceIds: { $set: syncErrorSpaceIds }
    });

  default:
    return state;
  }
}
